export const GET_PRIVATE_GLOBAL_ALERTS = 'GET_PRIVATE_GLOBAL_ALERTS';
export const GET_PRIVATE_GLOBAL_ALERTS_SUCCESS = 'GET_PRIVATE_GLOBAL_ALERTS_SUCCESS';
export const GET_PRIVATE_GLOBAL_ALERTS_FAILURE = 'GET_PRIVATE_GLOBAL_ALERTS_FAILURE';
